"use client"

import { memo } from "react"
import { cn } from "@/lib/utils"
import { AnimateOnScroll } from "@/components/index"

interface BlogHeroProps {
  title?: string
  description?: string
  className?: string
}

export const BlogHero = memo(function BlogHero({
  title = "Blog",
  description = "Technical articles about AI solutions, infrastructure as code, and cloud development.",
  className
}: BlogHeroProps) {
  return (
    <section className={cn("pt-24 md:pt-32 pb-8 md:pb-12 bg-gradient-to-b from-bg to-bg-alt", className)}>
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <AnimateOnScroll variant="fade-up" className="max-w-3xl">
          <span className="inline-block text-[10px] sm:text-xs font-semibold text-primary uppercase tracking-[1.5px] mb-3 sm:mb-4">
            Resources
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-text mb-4 sm:mb-6 tracking-tight">
            {title}
          </h1>
          <p className="text-sm sm:text-base md:text-lg text-text-muted max-w-2xl leading-relaxed">
            {description}
          </p>
        </AnimateOnScroll>
      </div>
    </section>
  )
})
